import { all, fork } from 'redux-saga/effects';

import appointmentsReducer from './appointments/reducer';
import appointmentsSaga from './appointments/saga';

import contactsReducer, { successorsReducer } from './contacts/reducer';
import contactsSaga from './contacts/saga';

import externalTaxAuthorityReducer from './externalTaxAuthority/reducer';
import externalTaxAuthoritySaga from './externalTaxAuthority/saga';

import geocodingReducer from './geocoding/reducer';
import geocodingSaga from './geocoding/saga';

import makeAppointmentReducer from './makeAppointment/reducer';
import makeAppointmentSaga from './makeAppointment/saga';

import managementsReducer from './managements/reducer';
import managementsSaga from './managements/saga';

import searchInspectionReducer from './searchInspection/reducer';
import searchInspectionSaga from './searchInspection/saga';

import servicesReducer from './services/reducer';
import servicesSaga from './services/saga';

import slotsReducer from './slots/reducer';
import slotsSaga from './slots/saga';

import taxAuthoritiesReducer from './taxAuthorities/reducer';
import taxAuthoritiesSaga from './taxAuthorities/saga';

import taxAuthorityReducer from './taxAuthority/reducer';
import taxAuthoritySaga from './taxAuthority/saga';

import taxAuthorityAffiliatesReducer from './taxAuthorityAffiliates/reducer';
import taxAuthorityAffiliatesSaga from './taxAuthorityAffiliates/saga';

export const contactsReducers = {
  contactsList: contactsReducer,
  successors: successorsReducer,
  geocoding: geocodingReducer,
  searchedInspections: searchInspectionReducer,
  managements: managementsReducer,
  taxAuthorities: taxAuthoritiesReducer,
  services: servicesReducer,
  slots: slotsReducer,
  makeAppointment: makeAppointmentReducer,
  taxAuthorityAffiliates: taxAuthorityAffiliatesReducer,
  appointments: appointmentsReducer,
  taxAuthority: taxAuthorityReducer,
  externalTaxAuthority: externalTaxAuthorityReducer,
};

export function* contactsSagas() {
  yield all(
    [
      contactsSaga,
      geocodingSaga,
      searchInspectionSaga,
      managementsSaga,
      taxAuthoritiesSaga,
      servicesSaga,
      slotsSaga,
      makeAppointmentSaga,
      taxAuthorityAffiliatesSaga,
      appointmentsSaga,
      taxAuthoritySaga,
      externalTaxAuthoritySaga,
    ].map(function (saga) {
      return fork(saga);
    }),
  );
}
